<script setup lang="ts">
import ChapterMcqPage from "~/features/computer/components/ChapterMcqPage.vue";
</script>

<template>
  <ChapterMcqPage unit="legal-ethics" />
</template>
